import { IPageData } from '../../models/analytics';
import { setPageDetails } from '../analytics';

const BASE = 'account>guest order tracking';
const MAML = 'maml:guest order tracking';
const MY_ACCOUNT = 'account';

/**
 * Page analtyics for Guest Order Tracking
 */

export const setGuestOrderTrackingPageAnalytics = () => {
  const linkedAccountsPageData: IPageData = {
    pageInfo: {
      pageName: BASE,
      pageType: MAML,
    },
    category: {
      primaryCategory: MY_ACCOUNT,
      subCategory1: BASE,
      subCategory2: BASE,
    },
  };
  setPageDetails(linkedAccountsPageData);
};
